import { useFlowsSelector } from '../../../common/src/utils/globalVariables';
import { useFlowsRouteParams } from './useFlowsRouteParams';

const useFlowsCurrentTag = (): string | undefined => {
  const { position } = useFlowsRouteParams();
  const lastPosition = useFlowsSelector(
    (state) => state.flowsMetaData.lastPosition,
  );
  const currentTag = useFlowsSelector((state) =>
    position === 'overview'
      ? state.flows.questionnaire.groups[lastPosition]?.tag
      : state.flows.questionnaire.groups[position || '']?.tag,
  );

  return currentTag;
};

export default useFlowsCurrentTag;
